var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pinyin"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"wordBox"},[_c('ruby',[_vm._v(_vm._s(item['hanzi'])+" "),_c('rt',[_vm._v(_vm._s(item['pinyin']))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }